module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-panel"
  }, [_c('div', {
    staticClass: "upload-dropzone",
    class: {
      'upload-dropzone-active': _vm.dragActive
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragActive = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragActive = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.handleDrop.apply(null, arguments)
      },
      "click": function($event) {
        return _vm.$refs.fileInput.click()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload upload-dropzone-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "upload-dropzone-text"
  }, [_vm._v("Drag and drop your CSV here, or click to browse")]), _vm._v(" "), (_vm.fileName) ? _c('p', {
    staticClass: "upload-dropzone-filename"
  }, [_vm._v(_vm._s(_vm.fileName))]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "upload-file-input",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFileInput
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-template-row"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadTemplate.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download CSV template\n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "upload-paste"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastedIds),
      expression: "pastedIds"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": _vm.pastePlaceholder
    },
    domProps: {
      "value": (_vm.pastedIds)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastedIds = $event.target.value
      }, _vm.handlePastedIds]
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.rows.length) ? _c('div', {
    staticClass: "upload-summary"
  }, [_c('span', {
    staticClass: "upload-summary-stat"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalRows))]), _vm._v(" total rows")]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-stat upload-summary-valid"
  }, [_c('strong', [_vm._v(_vm._s(_vm.validAccountIds.length))]), _vm._v(" valid")]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-stat upload-summary-error"
  }, [_c('strong', [_vm._v(_vm._s(_vm.invalidRows.length))]), _vm._v(" error" + _vm._s(_vm.invalidRows.length === 1 ? '' : 's') + "\n      "), (_vm.invalidRows.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showErrors = !_vm.showErrors
      }
    }
  }, [_vm._v(_vm._s(_vm.showErrors ? 'hide' : 'view'))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "upload-summary-stat"
  }, [_vm._v("STOP exclusions applied automatically when the audience count is calculated.")])]) : _vm._e(), _vm._v(" "), (_vm.showErrors) ? _c('ul', {
    staticClass: "upload-error-list"
  }, _vm._l((_vm.invalidRows), function(err) {
    return _c('li', {
      key: err.row
    }, [_vm._v("Row " + _vm._s(err.row) + ": " + _vm._s(err.reason))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.previewRows.length) ? _c('div', {
    staticClass: "upload-preview"
  }, [_c('label', [_vm._v("Preview (first 5 rows)")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_c('thead', [_c('tr', _vm._l((_vm.previewColumns), function(col) {
    return _c('th', {
      key: col
    }, [_vm._v(_vm._s(col))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.previewRows), function(row, index) {
    return _c('tr', {
      key: index
    }, _vm._l((_vm.previewColumns), function(col) {
      return _c('td', {
        key: col
      }, [_vm._v(_vm._s(row[col]))])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-4"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Country")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "clearable": false,
      "placeholder": "--Choose a Country--",
      "options": _vm.countryOptions
    },
    on: {
      "input": _vm.handleCountryInput
    },
    model: {
      value: (_vm.countryName),
      callback: function($$v) {
        _vm.countryName = $$v
      },
      expression: "countryName"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.countryId) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-4"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Segment Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.segmentName),
      expression: "segmentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Segment name"
    },
    domProps: {
      "value": (_vm.segmentName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.segmentName = $event.target.value
      }, function($event) {
        _vm.nameManuallyEdited = true
      }]
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.segmentName.trim()) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please enter a segment name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.validAccountIds.length
    },
    on: {
      "click": _vm.getAudience
    }
  }, [_vm._v("Get Audience")]), _vm._v("\n       \n    "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.validAccountIds.length
    },
    on: {
      "click": _vm.saveSegment
    }
  }, [_vm._v("Save Segment")])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), _c('AudienceTable', {
    attrs: {
      "audienceData": _vm.audienceData,
      "audienceCount": _vm.audienceCount,
      "showTable": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "upload-template-note"
  }, [_vm._v("Template column: "), _c('code', [_vm._v("account_id")]), _vm._v(" (one per row).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "upload-paste-label"
  }, [_vm._v("Or paste account IDs "), _c('span', {
    staticClass: "upload-template-note"
  }, [_vm._v("(one per line, or comma/space separated)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "not-enforced-note"
  }, [_vm._v("\n    The richer PRD template (phone_number / name / market / language / journey_stage) needs a phone-to-account\n    resolution step that doesn't exist in this system yet — pending confirmation with engineering. Uploading by\n    "), _c('code', [_vm._v("account_id")]), _vm._v(" works end-to-end today against the same segment save/count contract as filter-built segments.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-59ad6d74","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/UploadAudiencePanel.vue
// module id = VBBY
// module chunks = 1